import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'amfe-flexible';

import Vant, { Toast, Dialog } from 'vant';
import 'vant/lib/index.css';
import axios from 'axios';

import { Base64 } from 'js-base64';

import moment from 'moment';
import './style/style.css';

Vue.prototype.$globalData = Vue.observable({
    phone1: null
});

// Vue.prototype.$globalData = Vue.observable({
    // phone1: '15730551967'
// });



Vue.use(ElementUI);

Vue.use(Vant);

Vue.use(Toast);
Vue.use(Dialog);
Vue.prototype.$http = axios;
Vue.prototype.$Base64 = Base64;
Vue.prototype.$moment = moment;

// Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
